import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/cal-ay/apps/web/modules/apps/categories/categories-view.tsx");
